var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrail0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 266.7 266.7",
    style: {
      enableBackground: "new 0 0 266.7 266.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:5.000000e-02;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,233.3C14.9,233.3,0,218.4,0,200V33.3C0,14.9,14.9,0,33.3,0s33.3,14.9,33.3,33.3V200 C66.7,218.4,51.7,233.3,33.3,233.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.3,266.7c-18.4,0-33.3-14.9-33.3-33.3v-200C100,14.9,114.9,0,133.3,0s33.3,14.9,33.3,33.3v200 C166.7,251.7,151.7,266.7,133.3,266.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.3,233.3c-18.4,0-33.3-14.9-33.3-33.3V33.3C200,14.9,214.9,0,233.3,0s33.3,14.9,33.3,33.3V200 C266.7,218.4,251.7,233.3,233.3,233.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrail0);
export default __webpack_public_path__ + "static/media/trail_0.9b697ac8121f30e6fe058505437f1682.svg";
export { ForwardRef as ReactComponent };